import { useSelector } from "react-redux";

export const usePermission = () => {
  const { role, permissions } = useSelector((state) => state.user);

  const isSuperAdminUser = role?.roleType === 1;

  const hasPermission = (module, action = "view") => {
    if (isSuperAdminUser) return true;
    if (!permissions || !Array.isArray(permissions)) return false;
    const modulePerm = permissions.find((p) => p.module === module);
    return modulePerm ? modulePerm[action] === true : false;
  };

  const canView = (module) => hasPermission(module, "view");
  const canCreate = (module) => hasPermission(module, "create");
  const canUpdate = (module) => hasPermission(module, "update");
  const canDelete = (module) => hasPermission(module, "delete");

  return {
    hasPermission,
    canView,
    canCreate,
    canUpdate,
    canDelete,
    isSuperAdmin: isSuperAdminUser,
    role,
    permissions,
  };
};
